export default __webpack_public_path__ + "static/media/665.ecd491b7.gif";